import { AuthErrorCode } from '../auth-core.const';

/**
 * The authority refused the credential chain itself: a refresh token that was
 * spent, revoked or outlived its lifetime. Unlike a network failure, retrying
 * cannot succeed, so the client ends the session instead of scheduling retries.
 *
 * A tagged `Error` rather than a subclass: the library targets ES5, where
 * `instanceof` does not survive extending `Error`.
 */
export function credentialRejected(message: string, cause?: unknown): Error {
  return Object.assign(new Error(message), {
    code: AuthErrorCode.CredentialRejected,
    cause,
  });
}

export function isCredentialRejected(error: unknown): boolean {
  return (
    error instanceof Error &&
    (error as { code?: unknown }).code === AuthErrorCode.CredentialRejected
  );
}
